import { createContext, useContext, useState } from "react";
import NotificationToast from "../components/NotificationToast/NotificationToast";
import styles from "../components/NotificationToast/NotificationToast.module.scss";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const showNotification = (message, status) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { id, message, status }]);
    setTimeout(() => removeNotification(id), 3000);
  };

  const removeNotification = (id) => {
    setNotifications((prev) =>
      prev.filter((notification) => notification.id !== id)
    );
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <div className={styles.notificationContainer}>
        {notifications.map((notification) => (
          <NotificationToast
            key={notification.id}
            id={notification.id}
            message={notification.message}
            status={notification.status}
            removeNotification={removeNotification}
          />
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
